import { Routes } from '@angular/router';
import { MainComponent } from './layouts/main/main.component';
import { SimpleComponent } from './layouts/simple/simple.component';
import { LoginComponent } from './feature/login/login.component';
import { HomeComponent } from './feature/home/home.component';
import { ComplaintTypeComponent } from './feature/complain-type/complaint-type.component';
import { ComplaintSubTypeComponent } from './feature/complaint-sub-type/complaint-sub-type.component';
import { UserRightsComponent } from './feature/user-rights/user-rights.component';
import { ComplaintComponent } from './feature/complaint/complaint.component';
import { ComplaintAddComponent } from './feature/complaint/complaint-add/complaint-add.component';
import { GroupsComponent } from "./feature/groups/groups.component";
import { WorkFlowStepsComponent } from "./feature/work-flow-steps/work-flow-steps.component";
import { DivisionComponent } from "./feature/division/division.component";
import { GroupUsersComponent } from "./feature/group-users/group-users.component";
import { DistrictComponent } from "./feature/district/district.component";
import { TehsilComponent } from "./feature/tehsil/tehsil.component";
import { MouzaComponent } from "./feature/mouza/mouza.component";
import { authGuard } from './core/services/auth-gaurd.service';
import { UserRegistrationComponent } from './feature/user-registration/user-registration.component';
import { ComplaintEditComponent } from "./feature/complaint/complaint-edit/complaint-edit.component";
import { ComplaintViewComponent } from "./feature/complaint/complaint-view/complaint-view.component";
import { GroupRightsComponent } from "./feature/group-rights/group-rights.component";
import { UserGroupsComponent } from "./feature/user-groups/user-groups.component";
import { DashboardComponent } from './feature/dashboard/dashboard.component';
import { DashboardTwoComponent } from './feature/dashboard-two/dashboard-two.component';
import { DashboardThreeComponent } from './feature/dashboard-three/dashboard-three.component';
import { DashboardFourComponent } from './feature/dashboard-four/dashboard-four.component';
import { DashboardFiveComponent } from './feature/dashboard-five/dashboard-five.component';
import { DashboardDelayComponent } from './feature/dashboard-delay/dashboard-delay.component';
import { UserProfileComponent } from './feature/user-profile/user-profile.component';
import { ForgetPasswordComponent } from './feature/forget-password/forget-password.component';
import { SmsTrackingComponent } from './feature/sms-tracking/sms-tracking.component';
import { FailedQueriesComponent } from './feature/citizen-chatbot/failed-queries/failed-queries.component';
import { ChatLogsComponent } from './feature/citizen-chatbot/chat-logs/chat-logs.component';
import { QueriesComponent } from './feature/citizen-chatbot/queries/queries.component';
import { WebsiteUrlIngestionComponent } from './feature/citizen-chatbot/website-url-ingestion/website-url-ingestion.component';
import { WhatsAppConversationsComponent } from './feature/whatsapp/conversations/conversations.component';
import { WhatsAppAiAgentConversationsComponent } from './feature/whatsapp/ai-agent-conversations/ai-agent-conversations.component';
import { ComplaintAssistComponent } from './feature/citizen-chatbot/complaint-assist/complaint-assist.component';
import { EmailComplaintsComponent } from './feature/email-complaints/email-complaints.component';
import { EmailDetailComponent } from './feature/email-complaints/email-detail/email-detail.component';
import { EmailComplaintDataViewComponent } from './feature/email-complaints/email-complaint-data-view/email-complaint-data-view.component';
import { CsrConsoleComponent } from './feature/csr/csr-console/csr-console.component';
import { CsrHistoryComponent } from './feature/csr/csr-history/csr-history.component';
import { CsrExtensionStatusComponent } from './feature/csr/csr-extension-status/csr-extension-status.component';
import { CsrLiveMessagesComponent } from './feature/csr/csr-live-messages/csr-live-messages.component';
import { SupervisorControlRoomComponent } from './feature/supervisor/supervisor-control-room/supervisor-control-room.component';
import { SupervisorAgentWallboardComponent } from './feature/supervisor/supervisor-agent-wallboard/supervisor-agent-wallboard.component';
import { SupervisorQueueMonitorComponent } from './feature/supervisor/supervisor-queue-monitor/supervisor-queue-monitor.component';
import { SupervisorLiveChatsComponent } from './feature/supervisor/supervisor-live-chats/supervisor-live-chats.component';
import { RndVoiceTranscriptionComponent } from './feature/rnd/voice-transcription/rnd-voice-transcription.component';
import { RndTextToSpeechComponent } from './feature/rnd/text-to-speech/rnd-text-to-speech.component';
import { PiperTtsLabComponent } from './feature/rnd/piper-tts-lab/piper-tts-lab.component';
import { IndicParlerTtsComponent } from './feature/rnd/indicparler-tts/indicparler-tts.component';
import { IvrMemoryComponent } from './feature/rnd/ivr-memory/ivr-memory.component';
import { RndGemmaVoiceFunctionComponent } from './feature/rnd/gemma-voice-function/rnd-gemma-voice-function.component';
import { AiAdminAssistantComponent } from './feature/rnd/ai-admin-assistant/ai-admin-assistant.component';
import { RndDashboardComponent } from './feature/rnd/rnd-dashboard/rnd-dashboard.component';
import { RndWhisperBenchmarkComponent } from './feature/rnd/whisper-benchmark/rnd-whisper-benchmark.component';
import { RndContextAgentLabComponent } from './feature/rnd/context-agent-lab/rnd-context-agent-lab.component';
import { RndAiCallSimulatorComponent } from './feature/rnd/ai-call-simulator/rnd-ai-call-simulator.component';
import { PashtoDariSpeechComponent } from './feature/rnd/pashto-dari-speech/pashto-dari-speech.component';
import { TELEPHONY_PLUGIN_ROUTES } from './core/telephony/telephony-plugin.routes';
import { FacebookCommentsComponent } from './feature/social-media/facebook/facebook-comments.component';
import { YoutubeMonitoringComponent } from './feature/social-media/youtube-monitoring/youtube-monitoring.component';
import { ReliabilityDashboardComponent } from './feature/reliability/reliability-dashboard.component';
import { OmnichannelInboxComponent } from './feature/omnichannel/omnichannel-inbox/omnichannel-inbox.component';
import { TrainingHistoryComponent } from './feature/citizen-chatbot/training-history/training-history.component';
import { UploadDocumentsComponent } from './feature/internal-chatbot/upload-documents/upload-documents.component';
import { UploadDocumentsHistoryComponent } from './feature/internal-chatbot/upload-documents-history/upload-documents-history.component';
import { ChatLogsComponent as InternalChatLogsComponent } from './feature/internal-chatbot/internal-chat-logs/internal-chat-logs.component';
import { DynamicDashboardV2Component } from './feature/dynamic-dashboard-v2/dynamic-dashboard-v2.component';
import { ApplicationsComponent } from './feature/administration/applications/applications.component';
import { NmsMultiAgentComponent } from './feature/administration/nms-multi-agent/nms-multi-agent.component';
import { ConverseGovernanceComponent } from './feature/ai-control/converse-governance/converse-governance.component';


export const routes: Routes = [{
    path: 'user',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', component: UserRegistrationComponent }],
}, {
    path: 'login',
    component: SimpleComponent,
    canActivate: [authGuard],
    children: [
        { path: '', component: LoginComponent },],
},
{
    path: 'forget-password',
    component: SimpleComponent,
    canActivate: [authGuard],
    children: [
        { path: '', component: ForgetPasswordComponent },],
},
{
    path: 'home',
    component: MainComponent,
    canActivate: [authGuard],
    children: [{ path: '', component: HomeComponent }],
}, {
    path: '',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', component: DashboardComponent },
    ],
}, {
    path: 'complaint-category',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', redirectTo: 'complaint-type', pathMatch: 'full' },
        { path: 'complaint-type', component: ComplaintTypeComponent },
        { path: 'complaint-subtype', component: ComplaintSubTypeComponent }
    ],
}, {
    path: 'complaint',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', component: ComplaintComponent },
        { path: 'add', component: ComplaintAddComponent },
        { path: 'edit', component: ComplaintAddComponent },
        { path: 'edit/:complaintId', component: ComplaintEditComponent },
    ],
},
{
    path: 'complaint',
    component: SimpleComponent,
    canActivate: [authGuard],
    children: [
        { path: 'view/:complaintId', component: ComplaintViewComponent },
    ],
},

{
    path: 'groups',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', component: GroupsComponent },
        { path: 'user-rights', component: UserRightsComponent },
        { path: 'group-users', component: GroupUsersComponent },
        { path: 'group-rights', component: GroupRightsComponent },
        { path: 'user-groups', component: UserGroupsComponent }
    ],
},
{
    path: 'work-flow-steps',
    component: MainComponent,
    canActivate: [authGuard],
    children: [{ path: '', component: WorkFlowStepsComponent }],
},
{
    path: 'region',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', redirectTo: 'division', pathMatch: 'full' },
        { path: 'division', component: DivisionComponent },
        { path: 'district', component: DistrictComponent },
        { path: 'tehsil', component: TehsilComponent },
        { path: 'mouza', component: MouzaComponent }
    ],
},
{
    path: 'dashboard',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', redirectTo: 'gender', pathMatch: 'full' },
        { path: 'gender', component: DashboardComponent },
        { path: 'complaints', component: DashboardTwoComponent },
        { path: 'csr', component: DashboardThreeComponent },
        { path: 'delay-complaints', component: DashboardDelayComponent },
        // { path: 'four', component: DashboardFourComponent },
        // { path: 'five', component: DashboardFiveComponent },
    ],
},
{
    path: 'profile',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', component: UserProfileComponent }
    ],
},
{
    path: 'sms-tracking',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', component: SmsTrackingComponent }
    ],
},
{
    path: 'citizen-chatbot',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', redirectTo: '/dashboard/gender', pathMatch: 'full' },
        { path: 'failed-queries', component: FailedQueriesComponent },
        { path: 'chat-logs', component: ChatLogsComponent },
        { path: 'queries', component: QueriesComponent },
        { path: 'complaint-assist', component: ComplaintAssistComponent },
        { path: 'training-history', component: TrainingHistoryComponent },
        { path: 'website-urls', component: WebsiteUrlIngestionComponent },
    ],
},
{
    path: 'internal-chatbot',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', redirectTo: '/dashboard/gender', pathMatch: 'full' },
        { path: 'documents', component: UploadDocumentsComponent },
        { path: 'documents-history', component: UploadDocumentsHistoryComponent },
        { path: 'chat-logs', component: InternalChatLogsComponent },
    ],
},
{
    path: 'dynamic-dashboard',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', redirectTo: 'v2', pathMatch: 'full' },
        { path: 'v2', component: DynamicDashboardV2Component },
    ],
},
{
    path: 'whatsapp-log-screen',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', component: WhatsAppConversationsComponent }
    ],
},
{
    path: 'whatsapp-ai-agent-conversations',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', component: WhatsAppAiAgentConversationsComponent }
    ],
},
// {
//     path: 'email-complaints-demo',
//     component: EmailComplaintsComponent
// },
{
    path: 'email-complaints',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', component: EmailComplaintsComponent },
        { path: 'review/:intakeId', component: EmailComplaintDataViewComponent },
        { path: ':id', component: EmailDetailComponent }
    ],
},
{
    path: 'telephony',
    component: MainComponent,
    canActivate: [authGuard],
    children: TELEPHONY_PLUGIN_ROUTES,
},
{
    path: 'contact-center',
    component: MainComponent,
    canActivate: [authGuard],
    children: TELEPHONY_PLUGIN_ROUTES,
},
{
    path: 'call-center',
    component: MainComponent,
    canActivate: [authGuard],
    children: TELEPHONY_PLUGIN_ROUTES,
},
{
    path: 'csr',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', component: CsrConsoleComponent },
        { path: 'messages', component: CsrLiveMessagesComponent },
        { path: 'messages/history', component: CsrLiveMessagesComponent },
        { path: 'history', component: CsrHistoryComponent },
        { path: 'extensions', component: CsrExtensionStatusComponent },
    ],
},
{
    path: 'supervisor',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', redirectTo: 'control-room', pathMatch: 'full' },
        { path: 'control-room', component: SupervisorControlRoomComponent },
        { path: 'wallboard',    component: SupervisorAgentWallboardComponent },
        { path: 'queue-monitor',component: SupervisorQueueMonitorComponent },
        { path: 'live-chats', component: SupervisorLiveChatsComponent },
    ],
},
{
    path: 'ai-control',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', redirectTo: 'converse/overview', pathMatch: 'full' },
        { path: 'converse', redirectTo: 'converse/overview', pathMatch: 'full' },
        { path: 'converse', component: ConverseGovernanceComponent,
          children: [{path: ':page', children: [{path: ':section', children: []}]}] },
    ],
},
{
    path: 'rnd',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
        { path: 'dashboard', component: RndDashboardComponent },
        { path: 'voice-transcription', component: RndVoiceTranscriptionComponent },
        { path: 'text-to-speech', component: RndTextToSpeechComponent },
        { path: 'piper-tts', component: PiperTtsLabComponent },
        { path: 'xtts-urdu', component: IndicParlerTtsComponent },
        { path: 'ivr-memory', component: IvrMemoryComponent,
          canDeactivate: [(component: IvrMemoryComponent) => !component.dirty || window.confirm('Leave without saving memory settings?')],
          children: [{path: ':page', children: [{path: ':section', children: []}]}] },
        { path: 'indicparler-tts', redirectTo: 'xtts-urdu', pathMatch: 'full' },
        { path: 'gemma-voice-function', component: RndGemmaVoiceFunctionComponent },
        { path: 'ai-admin-assistant', component: AiAdminAssistantComponent },
        { path: 'whisper-benchmark', component: RndWhisperBenchmarkComponent },
        { path: 'context-agent-lab', component: RndContextAgentLabComponent },
        { path: 'ai-call-simulator', component: RndAiCallSimulatorComponent },
        { path: 'pashto-dari-speech', component: PashtoDariSpeechComponent },
    ],
},
{
    path: 'social-media',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', redirectTo: 'facebook', pathMatch: 'full' },
        { path: 'facebook', component: FacebookCommentsComponent, data: { source: 'FACEBOOK' } },
        { path: 'instagram', component: FacebookCommentsComponent, data: { source: 'INSTAGRAM' } },
        { path: 'youtube-monitoring', component: YoutubeMonitoringComponent },
    ],
},
{
    path: 'omnichannel',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', redirectTo: 'inbox', pathMatch: 'full' },
        { path: 'inbox', component: OmnichannelInboxComponent },
    ],
},
{
    path: 'administration',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', redirectTo: 'applications', pathMatch: 'full' },
        { path: 'applications', component: ApplicationsComponent },
        { path: 'nms-multi-agent', component: NmsMultiAgentComponent },
    ],
},
{
    path: 'reliability',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
        { path: '', component: ReliabilityDashboardComponent },
    ],
},
{
    path: '**',
    redirectTo: 'dashboard/gender'
}
];
